import { useAppSelector } from 'redux/hooks';
import { marketDrivenShippingSelector } from 'redux/slices/ecoms-slice';
import { EcomResponse_MarketDrivenShipping } from '../../pb/responses/v1/ecom_response_pb';

interface MarketDrivenShippingStatus {
    isMigrated: boolean;
    isActive: boolean;
    isLegacy: boolean;
}

const useMarketDrivenShippingStatus = (): MarketDrivenShippingStatus => {
    const marketDrivenShipping = useAppSelector(marketDrivenShippingSelector);

    return {
        isMigrated: marketDrivenShipping === EcomResponse_MarketDrivenShipping.MIGRATED,
        isActive: marketDrivenShipping === EcomResponse_MarketDrivenShipping.ACTIVE,
        isLegacy: marketDrivenShipping === EcomResponse_MarketDrivenShipping.LEGACY,
    };
};

export default useMarketDrivenShippingStatus;
